import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import { MainLogo} from "../../assets";
import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";
import FooterText from "../../components/footerText";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
      <div className="container-fluid login-sec pt-4 p-0 overflow-auto flex-fill">
          <div className="container">
              <div className="card bg-light">
                  <div className="card-body">
                      <div className="text-center mb-4">
                          <img className="img-fluid" src={MainLogo} style={{ height: '100px', width: '465px' }} alt="HeroImage" />
                      </div>
                      <form onSubmit={handleSubmit(submitPassword)}>
                          <Controller
                              name="password"
                              control={control}
                              defaultValue=''
                              render={({ field, fieldState: { error } }) => (
                                  <HubInputField
                                      inputId="password"
                                      isRowBased={false}
                                      isRequired={true}
                                      field={field}
                                      error={error}
                                      inputLabel="New Password"
                                      inputType="password"
                                  />
                              )}
                          />
                          <Controller
                              name="confirmPassword"
                              control={control}
                              defaultValue=''
                              render={({ field, fieldState: { error } }) => (
                                  <HubInputField
                                      inputId="confirmPassword"
                                      isRowBased={false}
                                      isRequired={true}
                                      field={field}
                                      error={error}
                                      inputLabel="Confirm Password"
                                      inputType="password"
                                  />
                              )}
                          />

                          <button disabled={loading} className="btn btn-primary" type="submit">
                              <div className="row align-items-center px-1">
                                  {loading ? (
                                      <div className="spinner-border text-light col-3" role="status">
                                          <span className="sr-only"></span>
                                      </div>
                                  ) : null}
                                  <p className="col-auto mb-0"> Reset Password </p>
                              </div>
                          </button>
                      </form>
                      <hr />
                      <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_CENTER} textColor="black" />
                  </div>
              </div>
          </div>
          <FooterText footerType="black" />
    </div>
  );
};

export default HubResetPassword;
